module.exports = __webpack_public_path__ + "img/363-67a7a9.png";